import React, {Component} from 'react';
import 'assets/sass/dashboard/common/BadgeRate.scss';

export class BadgeRate extends Component {
    render() {
        return (
            <div className={"badge-rate " + this.props.type}>
                <div className="badge-rate--icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.12 11.63">
                        <g>
                            <path
                                d="M8.82 5.25a1 1 0 0 1-.71.29 1 1 0 0 1-.7-.29L5.57 3.42v7.21a1 1 0 1 1-2 0V3.4L1.7 5.25a1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.42L3.85.28a1 1 0 0 1 1.41 0l3.56 3.55a1 1 0 0 1 0 1.42z"/>
                        </g>
                    </svg>
                </div>
                <div className="badge-rate--text">
                    {this.props.children}
                </div>
            </div>
        );
    }
}
